export var MainMarketsTypes;
(function (MainMarketsTypes) {
    MainMarketsTypes[MainMarketsTypes["ML"] = 1] = "ML";
    MainMarketsTypes[MainMarketsTypes["HC"] = 2] = "HC";
    MainMarketsTypes[MainMarketsTypes["OU"] = 3] = "OU";
})(MainMarketsTypes || (MainMarketsTypes = {}));
//# sourceMappingURL=MainMarketsTypes.js.map